import { useTranslation } from "react-i18next";
import { NeuInput } from "../../components/neu/Neu";

// حدّ التعبئة التلقائية وكمية الشراء.
export const AutoTopupFields = ({ form, set }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-4 grid gap-4 sm:grid-cols-2">
      <label className="block">
        <span className="label-xs">{t("wallet.autopayThreshold")}</span>
        <NeuInput
          type="number"
          data-testid="autopay-threshold"
          className="mt-2"
          value={form.threshold_tokens}
          onChange={(e) => set("threshold_tokens", e.target.value)}
        />
      </label>
      <label className="block">
        <span className="label-xs">{t("wallet.autopayAmount")}</span>
        <NeuInput
          type="number"
          data-testid="autopay-amount"
          className="mt-2"
          value={form.topup_tokens}
          onChange={(e) => set("topup_tokens", e.target.value)}
        />
      </label>
    </div>
  );
};
